import React, { CSSProperties, ReactNode, useState } from "react";
import classNames from "classnames";
import { Col, Row, Grid } from "antd";
import { DizzyIcon } from "@/icons/primary/dizzy-icon";
import { BemHelper } from "../../utils";
import { FloatingMenuOption } from "../floating-menu";
import { CloseIcon } from "@/icons/primary";

type Props = {
  icon?: ReactNode;
  description: string | React.ReactNode;
  style?: CSSProperties;
};

const { useBreakpoint } = Grid;

const bem = new BemHelper("pro-tip-message");

const IconDefault = () => (
  <>
    <span>Pro Tip</span>
    <DizzyIcon style={{ fontSize: 25 }} />
  </>
);

export const ProTipMessage: React.FC<Props> = ({ icon = <IconDefault />, description, style }) => {
  const screens = useBreakpoint();
  const [show, setShow] = useState(true);

  if (!show) {
    return null;
  }
  if (screens.xs) {
    return (
      <div className={classNames(bem.block())} style={style}>
        <Row justify='space-between' wrap={false} gutter={12}>
          <Col flex='none' className={classNames(bem.element("header"))}>
            {icon}
          </Col>
          <Col flex='none'>
            <FloatingMenuOption icon={<CloseIcon />} label='Close' onClick={() => setShow(false)} />
          </Col>
        </Row>
        <Row>
          <Col flex='auto'>{description}</Col>
        </Row>
      </div>
    );
  }

  return (
    <Row
      className={classNames(bem.block(), bem.modifier("desktop"))}
      style={style}
      justify='space-between'
      wrap={false}
      gutter={12}
    >
      <Col
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Row gutter={12} style={{ alignItems: "center" }}>
          <Col flex='none' className={classNames(bem.element("header"))}>
            {icon}
          </Col>
          <Col flex='auto'>{description}</Col>
        </Row>
      </Col>
      <Col
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <FloatingMenuOption icon={<CloseIcon />} label='Close' onClick={() => setShow(false)} />
      </Col>
    </Row>
  );
};
